import { getAccount } from 'wagmi/actions';
import { enums } from '@kattana-io/common';
import { ModalTypes } from '../../../reducers/modal';
import { WalletAPI } from '../../../store/createStore';

export const enableLimitsOverlay = (
  widget: any,
  chain: string,
  address: string,
  showNotification: Function,
  showModal: Function
) => {
  let showMarks = false;

  const toggleMarks: HTMLButtonElement = widget.createButton();
  toggleMarks.setAttribute('title', 'Limit orders marks');
  toggleMarks.textContent = 'Limits';
  toggleMarks.style.cursor = 'pointer';
  let shapeIds: string[] = [];
  const chart = widget.chart();

  const removeShapes = () => {
    showMarks = false;
    shapeIds.map((s) => {
      chart.removeEntity(s);
    });
    shapeIds = [];
  };

  toggleMarks.addEventListener('click', async () => {
    const usdConversion = widget._options.datafeed.usdConversion;
    const { address: wallet } = getAccount();

    if (wallet) {
      if (!showMarks) {
        try {
          const marks = await WalletAPI.fetchOverlayLimitOrders(
            wallet,
            chain,
            address
          );

          if (!marks?.length) {
            // showModal(ModalTypes.upgrade, {});
            return;
          }
          marks.forEach((m: any) => {
            if (m.status === enums.LimitOrderStatus.WATCH) {
              const shapeId = chart.createShape(
                { price: usdConversion ? m.price_usd : m.price },
                {
                  lock: true,
                  disableSave: true,
                  disableSelection: true,
                  shape: 'horizontal_line',
                  overrides: {
                    linecolor: m.gt ? '#D32F2F' : '#388E3C',
                  },
                }
              );
              shapeIds.push(shapeId);
            }
          });
          showMarks = true;
        } catch (e) {
          console.log(e);
        }
      } else {
        removeShapes();
      }
    } else {
      showNotification({
        kind: 'info',
        message: 'Connect wallet to enable this feature',
      });
    }
  });

  return () => {
    removeShapes();
  };
};
